import _isPlainObject from 'lodash/isPlainObject'
import _isArray from 'lodash/isArray'
import _set from 'lodash/set'
import _has from 'lodash/has'
import _get from 'lodash/get'

interface ObjectWithId {
  _id: string
  [key: string]: any
}

type DataValue = ObjectWithId | ObjectWithId[] | any

interface DataObject {
  [key: string]: DataValue
}

// One level of stripping ['machines', 'observers', 'owner']
// NOT ['permissions.site']
// Mutates data.
function strip(key: string, data: DataObject): void {
  if (_isPlainObject(data[key])) {
    const value = data[key] as ObjectWithId
    if (value._id) {
      data[key] = value._id
    }
  } else if (_isArray(data[key])) {
    const arrayValue = data[key] as any[]
    data[key] = arrayValue.map((item: any) => {
      return (_isPlainObject(item) && item._id) ? item._id : item
    })
  }
}

export function stripToIdOnly(keys: string[], data: DataObject): void {
  keys.forEach(key => strip(key, data))
}